import { createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from './reducers'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['isLogged', 'selectedUser', 'selectedTrail']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

// const defaultState = {
//   isLogged: false,
//   users: [],
//   trails: [],
//   selectedUser: {},
//   selectedTrail: {}
// }

// const store = createStore(rootReducer, defaultState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

// export default store

export const store = createStore(persistedReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
export const persistor = persistStore(store)